import React, {useContext, useState, useEffect} from 'react'
import { Routes, Route } from 'react-router-dom';
import { GlobalState } from '../../GlobalState';
import MainPage from '../mainPage/MainPage'
import MainPageAd from '../admin/MainPage';
import Login from '../admin/Login';

export default function Router() {
  const state = useContext(GlobalState)
  const [islogged] = state.isAuthenticated
  const [admin] = state.adminAPI.admin
  const [checked, setChecked] = useState(false)
  const [accounts] = state.accounts

  useEffect(()=>{
    const checkLogin = ()=>{
      // admin.forEach(el=>{
      //   if(el.email===accounts){
      //     setChecked(true)
      //   }
      // })
      if(sessionStorage.getItem('islogged')){
        setChecked(true)
      }
    }
    checkLogin()
  })

  // console.log(accounts)

  return (
    <Routes>
        <Route path="/sinhhoatdaukhoa2024" element={<MainPage />} />
        <Route path="/admin" element={checked ? <MainPageAd /> : <Login />} />
    </Routes>
  )
}
